module.exports = __webpack_public_path__ + "static/media/sunset-min.c8ba9182.png";